module.exports = __webpack_public_path__ + "media/images/element/earn-money-018a042595ecc0962ea5e8b7964a8709.svg";